import { useEffect } from 'react';
import { useOverlayContext } from "./OverlayContext";
export function FunctionalLoader(_ref) {
  let {
    show,
    name = 'FunctionalLoader'
  } = _ref;
  const {
    startLoader,
    stopLoader
  } = useOverlayContext();
  useEffect(() => {
    if (show) {
      startLoader(name);
      return () => {
        stopLoader(name);
      };
    }
  }, [show, name]);
  return null;
}